var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 2.85413C5.05 2.85413 2.5 5.40413 2.5 12.6041C2.5 19.8041 5.05 22.3541 12.25 22.3541C19.45 22.3541 22 19.8041 22 12.6041C22 5.40413 19.45 2.85413 12.25 2.85413Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.46 11.3443L17.02 10.7143C17.42 10.2643 17.61 9.71428 17.61 9.16428C17.61 8.52428 17.34 7.87428 16.82 7.41428C15.86 6.56428 14.38 6.65428 13.52 7.61428L12.96 8.24428C13 8.26428 16.44 11.3143 16.46 11.3443Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06997 17.8743C9.85997 17.8743 10.86 17.6743 11.6 16.8443L15.48 12.4543C15.45 12.4343 12.01 9.38428 11.98 9.35428L8.09997 13.7443C6.66997 15.3643 7.69997 17.6143 7.70997 17.6343C7.71997 17.6643 7.74997 17.6943 7.77997 17.7043C7.78997 17.7043 8.34997 17.8743 9.06997 17.8743Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/EditSquare.1cb6db947a54b250c7ae64634bfd2ef8.svg";
export { ForwardRef as ReactComponent };